import styled from 'styled-components';

export const RadioButtonContainer = styled.div<{ alignment: string | null }>`
  display: flex;
  justify-content: left;
  flex-flow: row wrap;
  flex-direction: ${(props) =>
    props.alignment === 'vertical' ? 'column' : 'row'};
  align-items: ${(props) =>
    props.alignment === 'vertical' ? 'flex-start' : 'center'};
`;
